import * as React from "react";
import { RemoteParticipant } from "twilio-video";
import { useTwilioContext } from "../../context/TwilioProvider";

export default function useParticipants() {
	const { room } = useTwilioContext();
	const [participants, setParticipants] = React.useState(Array.from(room?.participants.values() ?? []));

	React.useEffect(() => {
		if (room) {
			const participantConnected = (participant: RemoteParticipant) =>
				setParticipants((prevParticipants) => [...prevParticipants, participant]);
			const participantDisconnected = (participant: RemoteParticipant) =>
				setParticipants((prevParticipants) => prevParticipants.filter((p) => p !== participant));
			room.on("participantConnected", participantConnected);
			room.on("participantDisconnected", participantDisconnected);
			return () => {
				room.off("participantConnected", participantConnected);
				room.off("participantDisconnected", participantDisconnected);
			};
		}
	}, [room]);

	return participants;
}
